<div class="loading-shade" *ngIf="PageIsLoading$ | async">
    <mat-spinner></mat-spinner>
</div>
<app-multi-select-table
    mat-dialog-content
    *ngIf="ContentResolved$ | async; else loading"
    [TableData]="TableData$ | async"
    [TableDataConfig]="TableDataConfig$ | async"
    [Selected]="SelectedCustomers$ | async"
    [ServerSideSort]="true"
    (SortChange)="sortChange$.next($event)"
    (ClickSelected)="clickSelected($event)"
    (RemoveSelected)="RemoveSelected($event)"
    [EmptyText]="'Keine ' + (cls.getMultiple$('CustomerSupplier') | async) + ' gefunden'"
    Headline=""
    [SearchPlaceHolder]="'nach ' + (cls.getMultiple$('CustomerSupplier', 'Dativ') | async) + ' suchen'"
    [SelectedHeadline]="'Zugewiesene ' + (cls.getMultiple$('CustomerSupplier') | async)"
    (SearchStringChange)="SearchString.next($event)"
    (RowClick)="$event.selectedForm.disabled ? {} : $event.selectedForm.setValue(!$event.selectedForm.value); this.dirty = true;"
>
    <div class="filter-wrapper">
        <button
            app-round-button
            Inverted
            [matBadge]="FilterAmount$ | async"
            matTooltip="Filter"
            [matBadgeOverlap]="true"
            [matBadgeHidden]="!(FilterAmount$ | async)"
            (click)="filter.Open()"
        >
            <fa-icon icon="filter"></fa-icon>
        </button>
        <app-filter-card UnlimitedHeight #filter [Settings]="FilterSettings$ | async" [Values]="FilterValues$ | async" (ValuesChange)="FilterValues$.next($event)"></app-filter-card>
    </div>
</app-multi-select-table>


<mat-paginator
    class="select-customer-paginator"
    [pageSize]="pageSize$ | async"
    [length]="length$ | async"
    [showFirstLastButtons]="false"
></mat-paginator>

<ng-template #loading>
    <app-loading></app-loading>
</ng-template>
